import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import posIcon from '@/assets/others/location.png';
import newMap from "./newMap.vue";
export default {
  name: 'MapLineString',
  components: {
    newMap: newMap
  },
  data: function data() {
    return {
      selectType: 1,
      types: [],
      plot: null,
      isCruve: false,
      useTools: true,
      useStyle: true,
      useText: false,
      placement: 'center-bottom',
      visible: false,
      mapCenter: [103.060297, 29.852877],
      posIcon: posIcon,
      title: '',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      searchurl: 'https://restapi.amap.com/v3/geocode/geo?key=44641f38739649861c9d7d31f69b4ac2',
      mapPointList: [],
      line: [],
      maptype: 'Amap',
      showFullscreen: false,
      windowWidth: document.body.offsetWidth,
      windowHeight: document.body.offsetHeight
    };
  },
  watch: {
    windowWidth: function windowWidth(val) {
      var that = this;
      that.windowWidth = val;
    },
    windowHeight: function windowHeight(val) {
      var that = this;
      that.windowHeight = val;
    }
  },
  methods: {
    // 地图画线功能点击确定后的回调
    labelPosition: function labelPosition(value) {
      this.mapPointList = value;
    },
    changeMap: function changeMap(e) {
      this.maptype = e.target.value;

      if (e.target.value == 'Amap') {
        this.$refs.newMap.changeType(e.target.value);
      } else {
        this.$refs.newMap.changeType('Amap2');
      }
    },
    searchMap: function searchMap() {
      var _this = this;

      if (this.title) {
        //可用filter限制搜索区域,限制参数填入adcode
        // const surl=this.searchurl+"&filter=511800&keywords="+this.title
        var surl = this.searchurl + '&keywords=' + this.title;
        var that = this;
        this.$jsonp(surl).then(function (res) {
          if (res && res.geocodes && res.geocodes.length > 0) {
            var location = res.geocodes[0].location.split(',');

            _this.$refs.newMap.moveTo(location);
          } else {
            _this.$message_custom('未查询到对应数据', 'warning');
          }
        });
      } else {
        this.$message_custom('请输入需要搜索的关键字', 'warning');
      }
    },
    mapReady: function mapReady() {
      this.$refs.myMap.resize();
      this.$refs.myMap.moveTo(this.mapCenter);
    },
    show: function show(parmCenter) {
      var _this2 = this;

      this.line = [];

      if (parmCenter) {
        var pointList = parmCenter.split(':');
        this.line = pointList.map(function (v) {
          return v.split('-').map(function (item) {
            return item.split(',');
          });
        });
      }

      console.log(this.line, '回显');
      this.mapPointList = _toConsumableArray(this.line);
      this.selectType = 1;
      this.visible = true;
      this.$nextTick(function () {
        _this2.$refs.newMap.pipePositionList = _this2.line;
        _this2.$refs.newMap.center = window.localStorage.getItem('mapCenter').split(',');
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.maptype = 'Amap';
      this.mapReady();
    },
    handleOk: function handleOk() {
      this.$emit('mapChange', this.mapPointList);
      this.handleCancel();
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    drawLine: function drawLine() {
      this.finish();
      this.$refs.line.draw();
    },
    modify: function modify() {
      this.$refs.line.modify();
      this.$refs.circle.modify();
      this.$refs.polygon.modify();
    },
    finish: function finish() {
      this.$refs.line.finish();
      this.$refs.circle.finish();
      this.$refs.polygon.finish();
    },
    clear: function clear() {
      this.$refs.line.clear();
      this.$refs.circle.clear();
      this.$refs.polygon.clear();
      this.line = [];
      this.mapPointList = [];
    },
    drawend: function drawend(e) {
      this.mapPointList.push(e.target.sketchCoords_);
    },
    drawstart: function drawstart(e) {// console.log('drawstart', e)
    }
  }
};